import {
  GRAY_200,
  GRAY_300,
  GRAY_400,
  GRAY_75,
  GRAY_100,
  GRAY11,
  WHITE,
  PRIMARY_100,
  PRIMARY_300,
  PRIMARY_400,
  PRIMARY_600
} from "../../constant/colors";
import { columnResizeAndReorderStyle } from "@tailormed/common-client/component/ColumnResizeAndReorder/columnResizeAndReorderStyle";

export const commonBulkActionsTableStyle = (isFilterListView, hasSelection) => `
  margin-top: 10px;

  .ant-table-empty {
    margin: 35px 0px 40px 0px;

    .ant-table-thead > tr > .ant-table-cell:not(:first-child) {
      min-width: 50px;
    }
    .ant-table-tbody {
      height:  calc(100vh - 295px);
    }
  }

  .ant-table-thead {
    height: 36px; 
    max-height: 36px; 
    background: ${GRAY_100};
    position: sticky;
    top: 0;
    z-index: 12; /* Higher than action column (z-index: 11) to prevent selected row blue / the sticky pencil from showing through when scrolling */
  }

  .ant-table-thead > tr > .ant-table-cell {
    color: #000000;
    font-family: 'Open Sans', sans-serif;
    font-weight: 700;
    font-size: 12px;
    line-height: 12px;
    letter-spacing: 0;
    text-transform: uppercase;
    font-style: normal;
    vertical-align: middle;
    white-space: nowrap;
  }

  /* Add extra left padding to header text to align with body cells */
  .ant-table-thead > tr > .ant-table-cell:not(.ant-table-selection-column):not(.star-column) {
    padding-left: 18px !important;
  }

  .ant-table-cell {
    white-space: nowrap;   
    width: auto;  
    max-width: 100%;  
  }

  .ant-table-container table > thead > tr:first-child th:first-child {
    border-top-left-radius: 8px;
    border-left: 1px solid ${GRAY11};
  }

  .ant-table-container table > thead > tr:first-child th:last-child {
    border-top-right-radius: 8px;
    border-right: 1px solid ${GRAY11};
  }

  .ant-table-thead > tr > th {
    background: ${GRAY_100};
    border-bottom: 1px solid ${GRAY11};
    border-top: 1px solid ${GRAY11};
    padding: 8px 8px 8px 12px !important;
    vertical-align: middle;
  }

  .ant-table-tbody > tr > td {
    border-bottom: 1px solid ${GRAY11};
    padding:  5px 0px 5px 20px !important;
    transition: none !important;
  }

  .ant-table-tbody > tr > td:first-child {
    border-left: 1px solid ${GRAY11};
  }

  .ant-table-tbody > tr > td:last-child {
    border-right: 1px solid ${GRAY11};
  }

  /* Checkbox column styling - reduced padding for alignment */
  .ant-table-selection-column {
    padding: 0 4px 0 12px !important;
    text-align: center;
    vertical-align: middle;
    width: 36px !important;
    min-width: 36px !important;
    max-width: 36px !important;
  }

  .ant-table-thead .ant-table-selection-column {
    padding: 8px 4px 8px 12px !important;
    vertical-align: middle;
  }

  .ant-table-tbody .ant-table-selection-column {
    padding: 0 4px 0 12px !important;
    vertical-align: middle;
  }

  /* Indeterminate checkbox styling - blue background with white dash */
  .ant-checkbox-indeterminate .ant-checkbox-inner {
    background-color: #1677ff !important;
    border-color: #1677ff !important;
  }

  .ant-checkbox-indeterminate .ant-checkbox-inner::after {
    position: absolute !important;
    top: 50% !important;
    left: 50% !important;
    width: 8px !important;
    height: 2px !important;
    background-color: #fff !important;
    border: 0 !important;
    transform: translate(-50%, -50%) scale(1) !important;
    opacity: 1 !important;
    content: ' ' !important;
  }

  /* Star column styling - centered between checkbox and name */
  .star-column {
    padding: 0 2px 0 12px !important;
    text-align: center;
    vertical-align: middle;
    width: 32px !important;
    min-width: 32px !important;
    max-width: 32px !important;
  }

  .ant-table-thead .star-column {
    padding: 8px 2px 8px 12px !important;
    vertical-align: middle;
  }

  .ant-table-tbody .star-column {
    padding: 0 2px 0 12px !important;
    vertical-align: middle;
  }

  /* Star cell button alignment */
  .star-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .star-cell button {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    line-height: 0;
  }

  .star-cell button > span {
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 0;
  }

  /* Remove button hover background */
  .star-cell button.ant-btn-text:hover,
  .star-cell button.ant-btn-text:focus,
  .star-cell button.ant-btn-text:active {
    background-color: transparent !important;
  }

  /* Hide checkboxes by default, show on hover or when selection exists */
  ${
    !hasSelection
      ? `
    .ant-table-thead .ant-table-selection-column .ant-checkbox-wrapper {
      opacity: 0;
      transition: opacity 0.2s ease;
    }
    
    .ant-table-tbody .ant-table-selection-column .ant-checkbox-wrapper {
      opacity: 0;
      transition: opacity 0.2s ease;
    }
    
    /* Show header checkbox on header row hover */
    .ant-table-thead > tr:hover .ant-table-selection-column .ant-checkbox-wrapper {
      opacity: 1;
    }
    
    /* Show row checkbox on row hover */
    .ant-table-tbody > tr:hover .ant-table-selection-column .ant-checkbox-wrapper {
      opacity: 1;
    }
    
    /* Hide non-starred star icons by default */
    .ant-table-tbody .star-column .star-cell.not-starred {
      opacity: 0;
      transition: opacity 0.2s ease;
    }
    
    /* Show star icon on row hover */
    .ant-table-tbody > tr:hover .star-column .star-cell.not-starred {
      opacity: 1;
    }
    
    /* Always show starred (favorited) stars */
    .ant-table-tbody .star-column .star-cell.starred {
      opacity: 1;
    }
  `
      : `
    /* When there's a selection, always show all checkboxes */
    .ant-table-selection-column .ant-checkbox-wrapper {
      opacity: 1;
    }
    
    /* Hide non-starred star icons by default even when selection exists */
    .ant-table-tbody .star-column .star-cell.not-starred {
      opacity: 0;
      transition: opacity 0.2s ease;
    }
    
    /* Show star icon on row hover */
    .ant-table-tbody > tr:hover .star-column .star-cell.not-starred {
      opacity: 1;
    }
    
    /* Always show starred (favorited) stars */
    .ant-table-tbody .star-column .star-cell.starred {
      opacity: 1;
    }
  `
  }

  .ant-table-thead > tr > th > .ant-table-column-sorters {
    justify-content: space-between;
    align-items: center;
    gap: 8px;
  }

  .ant-table-thead > tr > th > .ant-table-column-sorters .ant-table-column-title {
    flex: initial;
    font-family: 'Open Sans', sans-serif;
    font-weight: 700;
    font-size: 12px;
    line-height: 12px;
    letter-spacing: 0;
    text-transform: uppercase;
    color: #000000;
  }

  .ant-table-thead > tr > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
    background-color: ${GRAY_100};
  }

  .ant-table {
    max-height: ${isFilterListView ? "calc(100vh - 285px)" : "calc(100vh - 240px)"};
    overflow: auto;
  }

  .horizontal-scroll {
    overflow-x: auto;
    position: sticky;
    bottom: 0;
    z-index: 12;
    background-color: ${WHITE};
  }

  .ant-pagination {
    position: sticky;
    bottom: 0;
    z-index: 1;
    left: 0;
    width: 100%;
    padding: 0px;
    background-color: ${WHITE};
    text-align: center;
  }

  /* Page number items - use flexbox for proper centering */
  .ant-pagination-item {
    border: none !important;
    background-color: transparent;
    min-width: 24px;
    height: 24px;
    border-radius: 100px;
    margin: 0 2px;
    display: flex !important;
    align-items: center;
    justify-content: center;
  }

  .ant-pagination-item a {
    font-family: 'Open Sans', sans-serif;
    font-weight: 600;
    font-size: 12px;
    line-height: 1.5;
    color: #000000;
    padding: 1px 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
    border-radius: 100px;
  }

  /* Hover state - light gray background (GRAY_200) */
  .ant-pagination-item:not(.ant-pagination-item-active):hover {
    background-color: transparent !important;
  }

  .ant-pagination-item:not(.ant-pagination-item-active):hover a {
    background-color: ${GRAY_200};
    color: #000000;
  }

  /* Active/selected state - blue background with white text */
  .ant-pagination-item-active {
    background-color: transparent !important;
    border: none !important;
  }

  .ant-pagination-item-active a {
    background-color: ${PRIMARY_600} !important;
    color: ${WHITE} !important;
  }

  .ant-pagination-item-active:hover a {
    background-color: ${PRIMARY_600} !important;
    color: ${WHITE} !important;
  }

  /* Previous/Next buttons */
  .ant-pagination-prev,
  .ant-pagination-next {
    min-width: 24px;
    height: 24px;
    margin: 0 2px;
    display: flex !important;
    align-items: center;
    justify-content: center;
  }

  .ant-pagination-prev button,
  .ant-pagination-next button {
    border: none;
    background: transparent;
    color: #000000;
    width: 24px;
    height: 24px;
    min-width: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100px;
    padding: 0;
  }

  /* Replace Ant Design's default arrows with clean chevron SVG */
  .ant-pagination-prev .ant-pagination-item-link,
  .ant-pagination-next .ant-pagination-item-link {
    display: flex;
    align-items: center;
    justify-content: center;
    border: none !important;
    background: transparent !important;
  }

  /* Hide Ant Design's default icon */
  .ant-pagination-prev .ant-pagination-item-link .anticon,
  .ant-pagination-next .ant-pagination-item-link .anticon {
    display: none;
  }

  /* Add left chevron icon using CSS ::after pseudo-element */
  .ant-pagination-prev .ant-pagination-item-link::after {
    content: '';
    display: block;
    width: 9px;
    height: 16px;
    background-image: url("data:image/svg+xml,%3Csvg width='9' height='16' viewBox='0 0 9 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8.25 0.75L1.25 7.75L8.25 14.75' stroke='%23000000' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }

  /* Right chevron for next button */
  .ant-pagination-next .ant-pagination-item-link::after {
    content: '';
    display: block;
    width: 9px;
    height: 16px;
    background-image: url("data:image/svg+xml,%3Csvg width='9' height='16' viewBox='0 0 9 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.750001 14.75L7.75 7.75L0.75 0.75' stroke='%23000000' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }

  .ant-pagination-prev:not(.ant-pagination-disabled):hover button,
  .ant-pagination-next:not(.ant-pagination-disabled):hover button {
    background-color: ${GRAY_200};
  }

  /* Disabled state - lighter arrow (GRAY_400) */
  .ant-pagination-disabled.ant-pagination-prev .ant-pagination-item-link::after {
    background-image: url("data:image/svg+xml,%3Csvg width='9' height='16' viewBox='0 0 9 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8.25 0.75L1.25 7.75L8.25 14.75' stroke='%2398A2B3' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  }

  .ant-pagination-disabled.ant-pagination-next .ant-pagination-item-link::after {
    background-image: url("data:image/svg+xml,%3Csvg width='9' height='16' viewBox='0 0 9 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.750001 14.75L7.75 7.75L0.75 0.75' stroke='%2398A2B3' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  }

  .ant-pagination-disabled button {
    cursor: not-allowed;
  }

  .ant-pagination-disabled:hover button {
    background-color: transparent !important;
  }

  /* Jump ellipsis (...) */
  .ant-pagination-jump-prev,
  .ant-pagination-jump-next {
    min-width: 24px;
    height: 24px;
    margin: 0 2px;
    display: flex !important;
    align-items: center;
    justify-content: center;
  }

  .ant-pagination-jump-prev .ant-pagination-item-container,
  .ant-pagination-jump-next .ant-pagination-item-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }

  /* Style the ellipsis icon to be black and centered */
  .ant-pagination-jump-prev .ant-pagination-item-ellipsis,
  .ant-pagination-jump-next .ant-pagination-item-ellipsis {
    color: #000000 !important;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    line-height: 24px;
  }

  /* Total text styling */
  .ant-pagination-total-text {
    font-family: 'Open Sans', sans-serif;
    font-size: 14px;
    line-height: 1.5;
    color: #000000;
    margin-right: 8px;
  }

  .ant-table::-webkit-scrollbar {
    -webkit-appearance: none;
  }

  .ant-table::-webkit-scrollbar:vertical {
    width: 15px;
  }

  .ant-table::-webkit-scrollbar-thumb {
    border-radius: 8px;
    border: 4px solid white;
    background-color: rgba(0, 0, 0, 0.2);
  }

  .ant-table-column-sorter-up,
  .ant-table-column-sorter-down {
    svg {
      display: none;
    }
  }

  /* Show sort triangles for all sortable columns */
  .ant-table-column-has-sorters .ant-table-column-sorter {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    margin-left: 4px;
  }

  /* Triangle styling */
  .ant-table-column-sorter-up,
  .ant-table-column-sorter-down {
    display: block;
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    margin: 0;
  }

  /* Up triangle - GRAY_300 by default (inactive state) */
  .ant-table-column-sorter-up {
    border-bottom: 6px solid ${GRAY_300};
    margin-bottom: 2px;
  }

  /* Down triangle - GRAY_300 by default (inactive state) */
  .ant-table-column-sorter-down {
    border-top: 6px solid ${GRAY_300};
  }

  /* Active (selected) sort triangle - PRIMARY_600 blue */
  .ant-table-column-sorter-up.active {
    border-bottom-color: ${PRIMARY_600};
  }

  .ant-table-column-sorter-down.active {
    border-top-color: ${PRIMARY_600};
  }

  /* Hover states - show which direction will be sorted next with darker gray */
  /* When not sorted or sorted descending, hovering highlights up arrow (will sort ascending) */
  .ant-table-thead th.ant-table-column-has-sorters:hover .ant-table-column-sorter-up:not(.active) {
    border-bottom-color: ${GRAY_400};
  }

  /* When sorted ascending, hovering highlights down arrow (will sort descending) */
  .ant-table-thead th.ant-table-column-has-sorters.ant-table-column-sort:hover .ant-table-column-sorter-up.active {
    border-bottom-color: ${PRIMARY_600};
  }

  .ant-table-thead th.ant-table-column-has-sorters.ant-table-column-sort:hover .ant-table-column-sorter-down:not(.active) {
    border-top-color: ${GRAY_400};
  }

  /* Action column - normal positioning, hidden by default */
  .ant-table-tbody > tr > td.action-column {
    background: transparent !important;
    border-left: none !important;
    transition: none !important;
  }

  /* Ensure action column stays transparent when row is not hovered and not selected */
  .ant-table-tbody > tr:not(.row-hovered):not(.ant-table-row-selected) > td.action-column {
    background: transparent !important;
    transition: none !important;
  }

  /* Action column header - normal styling to match other headers */
  .ant-table-thead > tr > th.action-column {
    background: ${GRAY_100} !important;
  }

  /* Ensure selected row background extends to all cells including action column */
  .ant-table-tbody > tr.ant-table-row-selected > td {
    background-color: ${PRIMARY_100} !important;
    transition: none !important;
  }

  /* Keep selected row blue even on hover - override Ant Design's gray hover */
  .ant-table-tbody > tr.ant-table-row-selected:hover > td {
    background-color: ${PRIMARY_100} !important;
    transition: none !important;
  }

  /* Action column positioning for selected+hovered rows */
  .ant-table-tbody > tr.ant-table-row-selected.row-hovered > td.action-column,
  .ant-table-tbody > tr.ant-table-row-selected.row-hovered:hover > td.action-column,
  .ant-table-tbody > tr.ant-table-row-selected:hover > td.action-column {
    position: sticky !important;
    right: 0 !important;
    z-index: 11;
    padding: 0 16px 0 0 !important;
  }

  /* Only show floating action on hovered row (non-selected) */
  .ant-table-tbody > tr.row-hovered:not(.ant-table-row-selected) > td.action-column,
  .ant-table-tbody > tr.row-hovered:not(.ant-table-row-selected):hover > td.action-column {
    position: sticky !important;
    right: 0 !important;
    z-index: 11;
    background: ${GRAY_75} !important;
    padding: 0 16px 0 0 !important;
    transition: none !important;
  }

  /* Gradient fade effect on left side of action column for non-selected rows */
  .ant-table-tbody > tr.row-hovered:not(.ant-table-row-selected) > td.action-column::before,
  .ant-table-tbody > tr.row-hovered:not(.ant-table-row-selected):hover > td.action-column::before {
    content: '';
    position: absolute;
    left: -40px;
    top: 0;
    width: 40px;
    height: 100%;
    background: linear-gradient(to right, transparent 0%, ${GRAY_75} 100%);
    pointer-events: none;
  }

  /* Gradient fade effect for selected rows - use blue background */
  .ant-table-tbody > tr.row-hovered.ant-table-row-selected > td.action-column::before,
  .ant-table-tbody > tr.row-hovered.ant-table-row-selected:hover > td.action-column::before {
    content: '';
    position: absolute;
    left: -40px;
    top: 0;
    width: 40px;
    height: 100%;
    background: linear-gradient(to right, rgba(209, 233, 255, 0) 0%, ${PRIMARY_100} 100%);
    pointer-events: none;
  }

  /* Also override Ant Design's hover background for the action cell */
  .ant-table-tbody > tr.row-hovered > td.action-column > div,
  .ant-table-tbody > tr.row-hovered:hover > td.action-column > div {
    background: transparent !important;
  }

  /* Selected row (bulk action): inline-edit hover affordances switch from grey to the primary
     palette — frame + empty-cell box border to Primary 300, the empty-cell "+" icon to Primary 400. */
  .ant-table-row-selected td:hover [data-testid$="-frame"],
  .ant-table-row-selected td:hover [data-testid^="inline-edit-empty-"],
  .ant-table-row-selected td:hover .tm-inline-edit-switch-frame {
    border-color: ${PRIMARY_300} !important;
  }
  .ant-table-row-selected td:hover [data-testid^="inline-edit-empty-"] .anticon {
    color: ${PRIMARY_400} !important;
  }

  ${columnResizeAndReorderStyle}
`;
